var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUganda(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "body_1",
    width: 19,
    height: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: 1
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M-85.3 0L597.3 0L597.3 512L-85.3 512L-85.3 0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.029166667 0 0 0.029166667 0.16666692 -0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9375 0 0 0.9375 80 0)",
    clipPath: "url(#1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-128 341.4L640 341.4L640 426.7L-128 426.7L-128 341.4z",
    stroke: "none",
    fill: "#FFE700",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-128 256L640 256L640 341.3L-128 341.3L-128 256z",
    stroke: "none",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-128 170.7L640 170.7L640 256L-128 256L-128 170.7z",
    stroke: "none",
    fill: "#DE3908",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-128 85.4L640 85.4L640 170.70001L-128 170.70001L-128 85.4z",
    stroke: "none",
    fill: "#FFE700",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-128 0L640 0L640 85.3L-128 85.3L-128 0z",
    stroke: "none",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.7 256C 335.7 284.47406 320.50928 310.7852 295.85 325.02222C 271.19073 339.25925 240.80927 339.25925 216.15 325.02222C 191.49072 310.7852 176.3 284.47406 176.30002 256C 176.3 211.98291 211.98291 176.3 256 176.3C 300.0171 176.3 335.7 211.98291 335.7 256z",
    stroke: "#000000",
    strokeWidth: 1,
    fill: "#FFFDFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 194.9L236.8 185.4C 238.8 183.4 242.1 181.79999 247.5 181.79999L247.5 181.79999L246.9 192.29999L241.9 194.9L242 194.9z",
    stroke: "#000000",
    strokeWidth: 1,
    fill: "#DE3108",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 192.3L247.7 181.8C 247.7 181.8 258.4 181.2 264.2 188.2L264.2 188.2L258.5 196.4L246.9 192.4L247 192.3z",
    stroke: "#000000",
    strokeWidth: 1,
    fill: "#FFE700",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.6 196.3L263.9 188.1C 267.4 191.8 268.9 194.40001 269.4 198.40001C 269.5 198.50002 261.1 200.50002 261.1 200.40001L261.1 200.40001L258.6 196.3z",
    stroke: "#000000",
    strokeWidth: 1,
    fill: "#DE3108",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.6 331.1C 244.6 331.1 254.5 319.80002 273.7 322.2C 270.80002 317.5 261.40002 318.1 261.40002 318.1C 261.40002 318.1 258.60004 296.1 260.80002 294.9C 263 293.69998 272.80002 295 272.80002 295C 274.00003 295 276.2 291.6 274.40002 289.4C 272.7 287.19998 267.60004 278.9 269.7 277.19998C 271.80002 275.59998 283.1 278.19998 283.1 278.19998L283.1 278.19998L251.1 237.19998C 251.1 237.19998 247.8 221.69998 254.40001 214.19998C 262.30002 207.69998 261.40002 200.59998 261.2 200.69998C 260.1 193.49998 249.20001 188.39998 241.80002 194.99998C 237.50002 200.19998 240.40002 204.19998 240.40002 204.19998C 240.40002 204.19998 228.90002 207.29999 228.50003 209.29999C 228.00003 211.29999 241.40002 208.99998 241.40002 208.99998L241.40002 208.99998L240.10002 218.09999C 240.10002 218.09999 214.10002 241.7 234.10002 262.09998L234.10002 262.09998L234.70003 261.3C 234.70003 261.3 241.70003 269.9 249.00003 271.8C 256.00003 278.8 255.30003 277.8 255.30003 277.8C 255.30003 277.8 256.60004 288.9 255.30003 291.09998C 253.60004 290.59998 236.00003 289.89996 233.40004 290.89996C 231.00005 291.69995 222.00005 291.19995 224.20004 305.99997L224.20004 305.99997L227.50005 298.49997C 227.50005 298.49997 227.20004 303.79996 229.40004 305.69998C 229.00005 300.09998 231.50005 296.3 231.50005 296.3C 231.50005 296.3 231.90004 302.5 233.30005 303.3C 234.70004 304.3 234.70004 293.3 242.30005 294.3C 249.70004 295.19998 255.20004 294.9 255.20004 294.9C 255.20004 294.9 257.70004 316.3 256.90005 318.3C 251.50006 317 238.50006 318.8 237.70006 322.09998C 245.30006 321.59998 248.80006 322.49997 248.80006 322.49997C 248.80006 322.49997 242.70006 327.99997 244.60007 331.09998L244.60007 331.09998L244.6 331.1z",
    stroke: "#000000",
    strokeWidth: 0.9,
    strokeLinecap: "square",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.6 214.8C 247.6 214.8 228.70001 235.6 236.90001 251.5C 237.3 249.3 237.1 247.9 237.40001 248C 236.90001 247.7 239.70001 249.9 239.50002 249.5C 239.50002 248.3 238.70001 245.8 238.70001 245.8L238.70001 245.8L241.20001 246.5L239.70001 243.7L243.40001 244.09999C 243.40001 244.09999 242.1 240.7 242.50002 240.7L242.50002 240.7L245.50002 240.9C 240.10002 231.29999 245.20001 223.29999 247.60002 214.7L247.60002 214.7L247.6 214.8z",
    stroke: "#9CA69C",
    strokeWidth: 0.9,
    strokeLinecap: "square",
    fill: "#9CA69C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.2 196.9C 254.2 196.9 255.2 204.09999 251.2 206.09999C 250.7 206.59999 248.2 207.4 248.59999 208.9C 248.99998 210.9 250.09999 210.5 251.59999 210.09999C 255.7 209.4 260.5 200.7 254.2 196.9z",
    stroke: "#9CA69C",
    strokeWidth: 1,
    fill: "#9CA69C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.2 203C 247.2 203.5359 246.9141 204.03108 246.45 204.29904C 245.9859 204.56699 245.4141 204.56699 244.95 204.29904C 244.4859 204.03108 244.2 203.5359 244.2 203C 244.2 202.17157 244.87157 201.5 245.7 201.5C 246.52843 201.5 247.2 202.17157 247.2 203z",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.1 209C 240.1 209.9 234.90001 215.3 240.1 217.3C 245.40001 215.90001 243.90001 214.90001 245.1 213.7C 245.1 211.2 242.5 210.59999 241.1 209.09999L241.1 209.09999L241.1 209z",
    stroke: "#000000",
    strokeWidth: 1,
    fill: "#DE3108",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.6 260.5C 252.3 261.7 251.1 266.1 252.70001 269.5C 257.30002 267.5 259.40002 268.1 260.90002 269.1C 257.2 266.1 255.70003 264.80002 252.60002 260.5L252.60002 260.5L252.6 260.5z",
    stroke: "#9CA69C",
    strokeWidth: 0.9,
    strokeLinecap: "square",
    fill: "#9CA69C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.4 281.1L260.6 291.30002C 260.6 291.30002 264.2 291.90002 265.80002 291.30002C 267.40002 290.7 265.80002 284.30002 260.40002 281.1L260.40002 281.1L260.4 281.1z",
    stroke: "#FFFFFF",
    strokeWidth: 0.9,
    strokeLinecap: "square",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 282.4C 286 282.4 279.5 266.6 262.8 262.6C 246.09998 258.6 248.29999 240.8 249.59999 239.70001C 250.4 238.20001 250.9 235.80002 255.7 238.1C 260.5 240.4 282.7 251.5 285.9 252.1C 289.09998 252.70001 286.3 282.80002 286.1 282.4L286.1 282.4L286 282.4z",
    stroke: "#000000",
    strokeWidth: 1,
    fill: "#9CA69C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.2 262.5C 269.90002 262.7 292.5 275.9 285.7 287.2C 292.1 282.90002 290.1 275.5 290.1 275.5C 290.1 275.5 295.30002 289.2 282.5 295.9C 283.9 297.1 284.8 296.9 284.8 296.9L284.8 296.9L282.59998 299C 282.59998 299 281.59998 300.7 290.19998 296.5C 287.9 298.4 287.69998 299.8 287.69998 299.8C 287.69998 299.8 288.3 301.59998 293.9 296.69998C 289.4 301.59998 288.4 304.09998 288.4 303.99997C 300.69998 302.99997 327.4 262.99997 280 251.29997L280 251.29997L282.1 253.49997L270.1 262.49997L270.2 262.5z",
    stroke: "#000000",
    strokeWidth: 0.9,
    fill: "#DE3108",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.2 258.6C 274.2 260.80002 275.30002 261.6 275.7 262.6C 272.90002 262 270.40002 262.2 270.40002 262.2C 270.40002 262.2 264.30002 256.40002 263.2 255.90001C 262.40002 255.90001 257.6 252.90001 257.6 252.90001C 255.3 251.70001 253.1 243.6 261.80002 245.90001C 265.1371 247.64034 268.57678 249.17651 272.1 250.50002L272.1 250.50002L282.80002 253.90001L289.00003 260.80002C 289.00003 260.80002 278.00003 255.40002 276.60004 255.30002C 279.60004 257.7 281.30005 261.1 281.30005 261.1C 277.80005 260.1 274.80005 259.1 271.20004 258.6L271.20004 258.6L271.2 258.6z",
    stroke: "#000000",
    strokeWidth: 0.9,
    strokeLinecap: "square",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.4 209.9C 228.4 209.9 238.9 207.29999 240.2 207.7",
    stroke: "#FFFFFF",
    strokeWidth: 0.9,
    strokeLinecap: "square",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-128 426.7L640 426.7L640 512L-128 512L-128 426.7z",
    stroke: "none",
    fill: "#DE3908",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUganda);
export default __webpack_public_path__ + "static/media/uganda.83c7bd8cd6d0650f888dee36c02e4307.svg";
export { ForwardRef as ReactComponent };